import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ProtectedRoute = ({ children, requiredPermission }) => {
  const { user } = useSelector((state) => state.Auth);

  // If the user is not authenticated, redirect to login
  if (!user?.data) {
    return <Navigate to="/" replace />;
  }

  const hasPermission =
    Array.isArray(requiredPermission)
      ? requiredPermission.includes(user?.data?.permission)
      : user?.data?.permission === requiredPermission;

  if (!hasPermission) {
    return <Navigate to="/404" replace />;
  }

  // Render children or nested routes if all checks pass
  return children ? children : <Outlet />;
};

export default ProtectedRoute;
